module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-500.9d13296.woff";